import { type IVesselFields } from "./VesselReports.model";

export const vesselFields: IVesselFields = {
  "0": [
    {
      label: "All",
      value: "*",
    },
    {
      label: "Number of open entries and required verifier / co-signer",
      value: "0",
    },
    {
      label:
        "Number of open entries by logbook titles and required verifier / co-signer",
      value: "1",
    },
    {
      label: "Reviews & Audits",
      value: "2",
    },
    {
      label: "All archived vessels with Account Manager name and archived date",
      value: "3",
    },
    {
      label: "All active vessels with Account Manager name and start date",
      value: "4",
    },
    {
      label: "List of subscribed titles by vessel",
      value: "5",
    },
    {
      label: "List of bolt ons by vessel",
      value: "6",
    },
    {
      label: "Subscription dates by vessel",
      value: "7",
    },
    {
      label: "Number of active, inactive and archived crew by vessel",
      value: "8",
    },
    {
      label: "Last access date and user by vessel",
      value: "9",
    },
  ],
  "2": [
    {
      label: "All",
      value: "*",
    },
    {
      label: "Name",
      value: "0",
    },
    {
      label: "Status",
      value: "1",
    },
    {
      label: "Account Manager",
      value: "2",
    },
    {
      label: "Subscription start date",
      value: "3",
    },
    {
      label: "Number of active/inactive/archived crew",
      value: "4",
    },
    {
      label: "Loogbook titles",
      value: "5",
    },
    {
      label: "Bolt ons",
      value: "6",
    },
    {
      label: "Last entry date",
      value: "7",
    },
    {
      label: "Last access date & user",
      value: "8",
    },
    {
      label: "Number of open entries",
      value: "9",
    },
  ],
};
